import styled from "styled-components";

export const NewsPageWrapper =  styled.div.attrs({
    className: 'NewsPageWrapper',
  })`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-x: hidden;
`;